<template>
  <main>
    <section>
      <h1>Add an Event</h1>
      <div>
        <label for="startdate">Event Start Date (for filtering)</label><br>
        <input v-model="startdate" type="date" id="startdate" name="startdate">
      </div>
      <div>
        <label for="enddate">Event End Date (for filtering)</label><br>
        <input v-model="enddate" type="date" id="enddate" name="enddate">
      </div>
      <div>
        <label for="date">Event Date Range (for display)</label><br>
        <input v-model="date" type="text" id="date" name="date">
      </div>
      <div>
        <label for="event">Event Name</label><br>
        <input v-model="event" type="text" id="event" name="event">
      </div>
      <div>
        <label for="studio">Studio or Business Name</label><br>
        <input v-model="studio" type="text" id="studio" name="studio">
      </div>
      <div>
        <label for="location">Location (City, State/Province)</label><br>
        <input v-model="location" type="text" id="location" name="location">
      </div>
      <div>
        <label for="country">Country (for filtering)</label><br>
        <select v-model="country" name="country" id="country">
          <option disabled value="">Please select one</option>
          <option v-for="(country, index) in countries" :key="index" :value="country.name">
            {{ country.name }}
          </option>
        </select>
      </div>
      <div>
        <label for="email">Email (not for display)</label><br>
        <input v-model="email" type="email" id="email" name="email">
      </div>
      <div>
        <label for="url">Website URL (for details &amp; registration)</label><br>
        <input v-model="url" type="text" id="url" name="url">
      </div>
      <button @click="addEvent" :class="{ disabledbutton: disabled }"  :disabled="disabled">Submit</button>
      <div>
        <p style="color:red; font-style:italic;">{{ message }}</p>
      </div>
    </section>
  </main>
</template>

<script>
  import ApiService from '@/js/ApiService.js';

  export default {
    name: 'addevent',

    metaInfo: {
      title: "Add Event",
      titleTemplate: "%s | Contrology | Balanced Body",
      meta: [
        {
          name: "description",
          content: "Add an event for Contrology Event Calendar consideration"
        },
        {
          name: "robots",
          content: "noindex, nofollow"
        },
        {
          property: "og:image",
          content: "https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-default.jpg"
        }
      ]
    },

    data() {
      return {
        startdate: '',
        enddate: '',
        date: '',
        event: '',
        studio: '',
        location: '',
        country: '',
        email: '',
        url: '',
        countries: [],
        message: "",
        disabled: false
      }
    },

    created() {
      this.fetchCountryList();
    },

    methods: {
      fetchCountryList() {
        this.message = "";
        this.loading = true;
        ApiService.getCountryList()
        .then(response => {
          this.loading = false;
          this.countries = response.data;
        })
        .catch(error => {
          this.loading = false;
          this.message = error;
          console.error(error);
        })
      },

      addEvent() {
        this.message = "";
        if ( this.startdate && this.enddate && this.date && this.event && this.studio && this.location && this.country && this.email && this.url) {
          ApiService.addEvent({
            startdate: this.startdate,
            enddate: this.enddate,
            date: this.date,
            event: this.event,
            studio: this.studio,
            location: this.location,
            country: this.country,
            email: this.email,
            url: this.url,
            published: false,
            joes_gym: false
          })
          .then(() => {
            this.message = "Your event information was submitted successfully.";
            this.disabled = true;
          })
          .catch(error => {
            this.message = "A problem occurred and your event information couldn't be submitted. Please try again later.";
            console.error(error);
          });
        }
        else {
          this.message = "All fields are required";
        }
      }
    }
  }
</script>

<style scoped lang="scss">
section {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
}

main div {
  margin: 10px 0;
  width: 100%;
  max-width: 400px;
}

label, p {
  font-family: var(--roboto);
  font-weight: 400;
  font-size: .875em;
  line-height: 1.614;
}

input,
select {
  border: 1px solid #5f6062;
  padding: 10px;
  width: 100%;
  max-width: 400px;
  font-size: 1em;
}

input[type="date"] {
  font-family: var(--roboto);
  font-size: 1em;
}

button {
  width: 100%;
  max-width: 400px;
  height: 40px;
  font-size: 1em;
  margin-top: 10px;
  border-color: var(--black);
  background-color: var(--black);
  color: var(--white);
  transition: .2s;
  cursor: pointer;
}

button:hover {
  background-color: gray;
}

.disabledbutton {
  background-color: #d8d8d8;
  color: #000;
  cursor: not-allowed;
}
</style>
